import React from 'react';
import stopIcon from '../../../../assets/stop.svg';
import {useAppStore} from "../../../../GlobalStore/GlobalStore.ts";

interface StopProps {}

const Stop: React.FC<StopProps> = ({ }) => {

    const environmentObj = useAppStore((state: any) => state.environmentObj);
    const { environment } = environmentObj;
    const updateElementInProgress = useAppStore((state: any) => state.updateElementInProgress);

    const handleStopClick = (event: React.MouseEvent) => {
        event.stopPropagation();
        updateElementInProgress('', 'abort');
    };

    const getButtonDimensions = () => {
        if (environment === "vscode") return "h-7 w-7";
        else return "h-8 w-8";
    }
    const buttonDimensions = getButtonDimensions();

    return (
        <button className={`${buttonDimensions}`} onClick={handleStopClick}>
            <img src={`${stopIcon}`} alt="Stop" />
        </button>
    );
};

export default Stop;
